export interface PagedResponse<T> {
  list: T[];
  count: number;
}

export type SortDirection = 'ASC' | 'DESC';

export type PagedParams<Filter = object> = Filter & {
  page: number;
  pageSize?: number;
  search: string | null;

  sortDirection: SortDirection;
};

export const currencyList = ['EUR', 'USD', 'GBP', 'RON', 'CHF'] as const;
export type Currency = (typeof currencyList)[number];

export interface PublishedAt {
  month?: number | null;
  year: number;
}

export interface PublishedAtRequest {
  month?: number | null;
  year: number;
}

export interface IdentityRequest {
  id: number;
}

export interface AuthorRequest {
  alias: string;
  membership: IdentityRequest;
}

export interface Membership {
  id: number;
  name: string;
}

export interface Author extends PartialAuthor {
  membership: Membership;
  affiliationName?: string;
  rorId?: string;
}

export interface PartialAuthor {
  id: number;
  orderNo: number;
  alias: string;
  userName: string;
  reclaimed: boolean;
  user: NamedEntity | null;
}

export type Id = number | string;

export interface NamedEntity {
  id: number;
  name: string;
}

export const jobTitleList = [
  'CONF',
  'LECTURER',
  'PROFESSOR',
  'ASSISTANT',
  'CS1',
  'CS2',
  'CS3',
  'RESEARCHER',
  'ASSISTANT_RESEARCHER',
] as const;

export type JobTitle = (typeof jobTitleList)[number];

export interface PersistentFile {
  id: number;
  sizeInBytes: number;
  contentType: string;
  title: string;
}

export interface BasicUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: JobTitle;
}
